let urlSearchParams;
let params;

if (typeof window !== 'undefined') {
  urlSearchParams = new URLSearchParams(window.location.search);
  params = Object.fromEntries(urlSearchParams.entries());
}

const plugin = {
  type: 'postProcessor',
  name: 'keyViewPlugin',
  process(value, key) {
    if (params?.showi18nKeys) {
      if (Array.isArray(key)) {
        return key[0];
      } else {
        return key;
      }
    }
    return value;
  },
};
export default plugin;
